/* eslint-disable jsx-a11y/anchor-is-valid */
import { IconArrowUpDown } from '@medifind/icons';
import styles from './SitemapToggle.module.scss';

export const SitemapToggle = ({ isExpanded, onToggle }) => {
  return (
    <button onClick={onToggle} className={styles['toggle-button']}>
      <div className={styles['toggle-button-container']}>
        <p>Site Map</p>
        <div>
          <IconArrowUpDown
            direction={isExpanded ? 'up' : 'down'}
            color="#fff"
            style={{ display: 'flex', justifyContent: 'center', opacity: '0.8', width: '12px', height: '12px' }}
          />
        </div>
      </div>
    </button>
  );
};
